export const tr = {
    'error-message': 'Sorgu yapılamadı, daha sonra tekrar deneyin.',
    'failed-to-delete-comment-message': 'Bu yorum silinemedi. Sayfayı yenileyin ve tekrar deneyin',
    'success-message':
        'Bu uzman hakkındaki geri bildiriminiz için teşekkürler! Geri bildiriminizi moderasyona gönderdik; bundan sonraki adım, geri bildiriminizin uzmanın sayfasında yayınlanması ve uzmanın değerlendirmesinde bu geri bildirimin dikkate alınmasıdır.'
};
